import React from "react";

const DeviceClockingSummary = () => {
    return <div>Device Clocking Summary</div>;
};

export default DeviceClockingSummary;